import { useTranslation } from "react-i18next";
import { HatchBandCorner, HatchBandOverFooter, hatchBandFooterEdge, cn } from "@jbnl/shared-ui";

/** The Brandweer Rood band across the foot of the page, as on the letterhead. */
export function Footer({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <footer
      className={cn("relative z-0 mt-auto bg-brand-red pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pl-6 text-xs text-white", hatchBandFooterEdge, className)}
    >
      <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-1">
        <span>{t("footer.stichting")}</span>
        <span className="font-bold">{t("footer.website")}</span>
      </div>
      <HatchBandCorner />
      <HatchBandOverFooter />
    </footer>
  );
}
